/**
 * @module project/components/participate_form/revision_step
 */
import React, { PropTypes, Component } from 'react';
import { v4 } from 'node-uuid';
import classNames from 'classnames';
import FormButtons from 'project/containers/participate_buttons';
import Thumbnail from 'common/components/thumbnail';
import idx from 'idx';
import filter from 'lodash/filter';

/**
 * Participate revision form step that allows selecting a revision from existing elements
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class RevisionStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entryId: null,
      isRevision: false,
    };

    this.setIsRevision = this.setIsRevision.bind(this);
    this.setIsNewEntry = this.setIsNewEntry.bind(this);
    this.selectEntry = this.selectEntry.bind(this);
    this.renderEntry = this.renderEntry.bind(this);
  }

  setIsRevision() {
    if (Object.keys(this.props.revisions).length) {
      this.setState({ isRevision: true });
    }
  }

  setIsNewEntry() {
    this.setState({ isRevision: false });
  }

  selectEntry(entryId, revision) {
    if (this.state.isRevision) {
      if (this.state.entryId === entryId) {
        this.setState({ entryId });
        this.props.onSelectEntry(null);
      } else {
        this.setState({ entryId });
        this.props.onSelectEntry(entryId, revision);
      }
    }
  }

  renderEntry(entry) {
    if (!entry.revisions.length) {
      return null;
    }

    const revision = this.props.revisions[entry.revisions[0]];
    const selected = (this.state.entryId === entry.id && this.state.isRevision);
    const thumbnailClass = classNames('tile actionable thumbnail flex', {
      selected,
    });

    return (
      <div key={v4()} className="column revision">
        <Thumbnail
          className={thumbnailClass}
          image={revision.image}
          onClick={() => { this.selectEntry(entry.id, revision); }}
        />
      </div>
    );
  }

  render() {
    const { entries, user } = this.props;
    const { isRevision, entryId } = this.state;
    const renderEntry = this.renderEntry;

    const userId = idx(user, _ => _.id);
    const entryList = filter(entries, ({ author }) => (author === userId));

    return (
            <div className="participate-step revision-step">
              <div className="modal-header">
                <h5>Submit Revision</h5>
              </div>
              <div className="modal-content">
                <div className="row collapse">
                  <div className="medium-6 columns">
                    <div className="participate-sidebar">
                      <div className="revision-benefits">
                        <h3>You&apos;ve already submitted to this project.</h3>
                        <p>
                          If the design you are uploading is a revision,
                          select it from the list on the right.
                        </p>
                        <p>Revisions benefit you by:</p>
                        <ul>
                          <li>Streamlining client feedback</li>
                          <li>Making it easier for you and the client to collaborate</li>
                          <li>Reducing clutter in the project gallery</li>
                        </ul>
                      </div>
                      <fieldset>
                        <div className="radio">
                          <input
                            id="is_revision_radio"
                            type="radio"
                            className="form-control"
                            checked={isRevision === true}
                            value={this.state.isRevision}
                            onChange={this.setIsRevision}
                          />
                          <label htmlFor="is_revision_radio" className="form-label">This is a revision</label>
                        </div>
                        <div className="radio">
                          <input
                            id="is_new_radio"
                            type="radio"
                            className="form-control"
                            checked={isRevision === false}
                            value={this.state.isRevision}
                            onChange={this.setIsNewEntry}
                          />
                          <label htmlFor="is_new_radio" className="form-label">This is a new entry</label>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  {isRevision &&
                  <div className="medium-10 columns">
                    <h4>This entry is a revision of:</h4>
                    <div className="revision-list">
                      <div className="row medium-up-2">
                        { Object.values(entryList).map(renderEntry) }
                      </div>
                    </div>
                  </div>
                  }
                </div>
                <div className="modal-actions right">
                  <FormButtons
                    nextActive={!!(isRevision && entryId) || !isRevision}
                    onToggleForm={this.props.onCloseForm}
                  />
                </div>
              </div>
            </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} project - project data object
 * @property {object} revisions - revisions by id object
 * @property {object} entries - entries by id object
 * @property {func} onSelecnEntry - function called when entry is selected from the list
 * @property {func} onCloseForm - function called when partpcipate form should be closed
 */
RevisionStep.propTypes = {
  project: PropTypes.object,
  revisions: PropTypes.object,
  entries: PropTypes.object,
  onSelectEntry: PropTypes.func,
  onCloseForm: PropTypes.func,
  user: PropTypes.object,
};



// WEBPACK FOOTER //
// ./project/components/participate_form/revision_step.jsx